import React from 'react'
import YourCardsInactive from 'src/app/YourCardsInactive/YourCardsInactive'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { yourCardsInactiveRouteProps } from 'src/navigation/routeProps'

const YourCardsInactiveAppRoute: AppRoute = {
  routeProps: yourCardsInactiveRouteProps,
  component: <YourCardsInactive />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default YourCardsInactiveAppRoute
